import React from 'react';
import { Card, Grid } from '@solarwindscloud/nighthawk-ui';
import styles from './CenterLayout.module.scss';

const CenterLayout = ({ children }) => {
  return (
    <Grid centered>
      <Grid.Column className={styles.centeredColumn}>
        <Card className={styles.noBorder}>
          <Card.Content>{children}</Card.Content>
        </Card>
      </Grid.Column>
    </Grid>
  );
};

CenterLayout.displayName = 'CenterLayout';

export default CenterLayout;
